import React, {Component} from 'react';
import axios from 'axios';
import {  withRouter } from "react-router-dom";
import GoogleMapReact from 'google-map-react';
//import ReactImageMagnify from 'react-image-magnify';
import { Alert } from 'reactstrap';
import auth0Client from '../Auth';
import {ToastContainer, ToastStore} from 'react-toasts';
import Toggle from "react-toggle-component"
//import "react-toggle-component/styles.css"
import Modal from 'react-responsive-modal';
import Claim from '../Claim/Claim';
import LostItemClaims from './LostItemClaims';
import LostItemFunctions from './LostItemFunctions';
import ReturnWizard from '../Shipments/ReturnWizard2';
import ReactImageMagnify from 'react-image-magnify';
import LostItemAuditChanged from './LostItemAuditChanges';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import DatePicker from "react-datepicker";
import {SERVER_URL, LOCAL_URL, CURRENCY_LIST, ATTACHMENT_OBJECT_TYPE_LOSTITEM}  from '../Constants';
import Attachments from '../Attachment/Attachments';
import Camera from '../Camera/Camera';
import moment from 'moment';



const AnyReactComponent = ({ text }) => <div><img src ="../images/pin.png" width="50px" height="50px" alt=""/></div>;



class LostItem extends Component {
  constructor(props) {
    super(props);

    
   // if (this.props && this.props.match.params.id
    let foundByName = (auth0Client.userData) ? (auth0Client.userData.lastName) +','+ (auth0Client.userData.firstName) : 'NA';
    let loggedByName = (auth0Client.userData) ? (auth0Client.userData.lastName) +','+ (auth0Client.userData.firstName) : 'NA';
    foundByName = (auth0Client.getDefaultVenue().disableAutoFillFinderInfo)? '' : foundByName;
    this.state = {
      venueid:-1,
      lostItem: null,
      id:-1,
      shortDescription: '',
      longDescription: '',
      disabled :false,
      publishPicture :false,
      center: {
        lat: 40,
        lng: -70,
      },
      zoom: 14,
      itemState:'Q',
      publishedDate: new Date(),
      keywords:'',
      claimCallengerDetails:'',
      foundDate: new Date(),
      showSuccess: false,
      locationName:'',
      showNewClaim: false,
      showOpenClaim: false,
      showNewReturn:false,
      selectedClaimId: '',
      refreshLostItemClaims:false,
      claims:[],
      isPublished:false,
      returnedDate:undefined,
      url:'../default-placeholder.png',
      storageLocation:'',
      foundById :'',
      isExpensiveItem: false,
      foundByName: foundByName,
      loggedByName:loggedByName,
      itemNumber:'',
      airportCd:'',
      terminal:'',
      flightNumber:'',
      seat:'',
      pnr:'',
      gate:'',
      venueTypeCd:'',
      section:'',
      row:'',
      parkingLot:'',
      contacted:false,
      contactedDate:undefined,
      donateDisposeNote:'',
      donateDisposeDate:undefined,
      displayAuditLog:false,
      barCodeValue:'',
      foundByEmployeeId:'',
      selectedClaim:undefined,
      containsCash : false,
      cashAmount:0.00,
      cashCurrencyCd:'',
      returnToFinderDate:undefined, //  moment(new Date()).add(30,'days').toDate()
      note:'',
      storageLocations:[],
      storageLocationId: '',
      showCamera:false,
      pic2Url:false,
      pic3Url:false,
      displayLargeImageModal:false,
      ownerName:'',
      isReturnedToStaff:false,
      returnedToStaffName:'',
      finderClaimed:false,
      surveillanceStaffName:'',
      category:'',
      categoriesMap:[],
      foundLocations:[],
      showLocationList:false,
    }


  }



  async componentDidMount() {
    const { match: { params } } = this.props;

    //console.log(params.lostItemId);

   // console.log(auth0Client.getDefaultVenue().venueTypeCd);
    
    this.setState({
      venueTypeCd:auth0Client.getDefaultVenue().venueTypeCd,
     
    })     
    if (auth0Client.getDefaultVenue().enableWarehouse){
      this.loadCheckInLocationsForStorage();
      this.loadLocationsForFoundItem();

    }
    if (params.lostItemId==='-1'){
      return;
    }

    //console.log(auth0Client.getProfile());

    const lostItem = (await axios.get(`${SERVER_URL}/LostItems/${params.lostItemId}`, {headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}` }})).data;
    
   if (lostItem===undefined){
     return;
   }
    
    this.setState({
        lostItem : lostItem,
        id: lostItem.id,
        itemState:lostItem.itemState,
        shortDescription: lostItem.shortDescription,
        longDescription: lostItem.longDescription, 
        locationName:lostItem.locationName,
        isPublished:lostItem.isPublished,
        url: (lostItem.url==='') ? '../default-placeholder.png' : lostItem.url, 
        center:  {
          lat: lostItem.latitude,
          lng: lostItem.longitude
        },
        published : lostItem.published,
        publishedDate: lostItem.publishedDate,
        publishPicture:lostItem.publishPicture,
        keywords:lostItem.keywords,
        claimCallengerDetails: lostItem.claimCallengerDetails,
         dateLost:new Date(),
        foundDate: (lostItem.foundDate) ? new Date(lostItem.foundDate) : new Date(),
        returnedDate : (lostItem.returnedDate) ? new Date(lostItem.returnedDate) : undefined,
        storageLocation:lostItem.storageLocation,
        isExpensiveItem:lostItem.isExpensiveItem,
        foundByName:lostItem.foundByName,
        loggedByName:lostItem.loggedByName,
        itemNumber : lostItem.itemNumber,
        airportCd:lostItem.airportCd,
        terminal:lostItem.terminal,
        flightNumber:lostItem.flightNumber,
        seat:lostItem.seat,
        pnr:lostItem.pnr,
        gate:lostItem.gate,
        section:lostItem.section,
        row:lostItem.row,
        parkingLot:lostItem.parkingLot,
        contacted:lostItem.contacted,
        contactedDate : (lostItem.contactedDate) ? new Date(lostItem.contactedDate) : undefined,
        donateDisposeNote:lostItem.donateDisposeNote,
        donateDisposeDate:(lostItem.donateDisposeDate) ? new Date(lostItem.donateDisposeDate) : undefined,
        barCodeValue:lostItem.barCodeValue,
        foundByEmployeeId:lostItem.foundByEmployeeId,
        containsCash : lostItem.containsCash,
        cashAmount:lostItem.cashAmount,
        cashCurrencyCd:lostItem.cashCurrencyCd,
        returnToFinderDate: (lostItem.returnToFinderDate) ? new Date(lostItem.returnToFinderDate) : undefined,
        note: (lostItem.claimCallengerDetails) ? lostItem.claimCallengerDetails : lostItem.note,
        releaseDate: (lostItem.releaseDate) ? new Date(lostItem.releaseDate) : undefined,
        storageLocationId: lostItem.storageLocationId,
        createdAt:(lostItem.createdAt) ? new Date(lostItem.createdAt) : undefined,
        updatedAt:(lostItem.updatedAt) ? new Date(lostItem.updatedAt) : undefined,
        pic2Url:lostItem.pic2Url,
        pic3Url:lostItem.pic3Url,
        ownerName:lostItem.ownerName,
        isReturnedToStaff:lostItem.isReturnedToStaff,
        returnedToStaffName:lostItem.returnedToStaffName,
        finderClaimed:lostItem.finderClaimed,
        surveillanceStaffName:lostItem.surveillanceStaffName,
        category:lostItem.category,
        foundLocations:[],
        suggestionLocations:[]
    });

    this.refreshClaims(lostItem.id);
    this.loadCategories();
   // this.initMap();
  }

  loadUsers =async () =>{
    const users = (await axios.get(`${SERVER_URL}/Users/`,{
      headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`,
      'venueId' : auth0Client.getActiveVenuedId()
     }
    })).data;
    if (users!==undefined){
      users.push({
        id : '',
        lastName:'',
        firstName:'',
      })
    }
  this.setState({
      users : users
      
  });
  
  }

  loadCategories = ()=>{
    try {
      axios.get(`${SERVER_URL}/Reports/reportCategories`,{
         headers: { 
           'Authorization': `Bearer ${auth0Client.getIdToken()}`,
           'venueId' : auth0Client.getActiveVenuedId()
         }
        
        }).then((res)=>{
         
         if (res.status===undefined || res.status !==200) {
           //place your reentry code
           console.log("Error" + res.status);
           ToastStore.error("An error occured. Please try again");
          }
 
         const categoriesMap = res.data.categoriesMap;
         // add a blank option
         categoriesMap.unshift({ "name": " ","subcat" : [ ]});
      
         this.setState({
          categoriesMap : categoriesMap,
          
          });


        },
        (error)=>{
          if (error.response && error.response.status === 401){
            ToastStore.error("Not Authorized, Please log out and log in again: " + error.message);
          }else {
            ToastStore.error('An error occured:' + error.message);
          }
          
        }
        );
    }catch(e){
        //console.log(e);
        ToastStore.error('An error occured:' + e.message);
    }


 }

  // Loads the check in locations for the storage selection list.  Warehouse accounts
  // can only select from a specific list.
  loadCheckInLocationsForStorage=async()=>{
    const checkInLocations = (await axios.post(`${SERVER_URL}/CheckInOut/CheckInLocations`,{}, {
      headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`,  'venueId' : auth0Client.getActiveVenuedId() }})).data;
    //console.log(checkInLocations);
    // Sort
    //if (checkInLocations){
    //  checkInLocations.sort(this.sortAlphaNum)
   // }
    this.setState({storageLocations:checkInLocations})
  }

 loadLocationsForFoundItem=async()=>{
    try{
      const foundLocations = (await axios.post(`${SERVER_URL}/locations/query`,{}, {
        headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`,  'venueId' : auth0Client.getActiveVenuedId() }})).data;
        let filteredList = [];
        for (var i=0; i < foundLocations.length; i++){
          if (foundLocations[i].typeCd==='EXPRESSQR'){
            filteredList.push(foundLocations[i]);
          }
        }
        this.setState({
          foundLocations:filteredList
          })
    }catch(e){
      console.log(e);
    }
  
   
 }
  handleInputChange=(event) =>{
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleInputStorageChange=(event) =>{
    const target = event.target;
    const value = target.value;
    let _id = ''
    for (var i=0; i < this.state.storageLocations.length; i++){
      if (this.state.storageLocations[i].name===target.value){
        _id=this.state.storageLocations[i]._id;
        break;
      }
    }
    // foundByName: (auth0Client.userData) ? (auth0Client.userData.lastName) : 'NA',
    //const name = target.name;
    //console.log('storageLocationID:' + _id)
    this.setState({
      storageLocation : value,
      storageLocationId: _id,
      loggedByName:  (auth0Client.userData) ? (auth0Client.userData.lastName) : '',
    });
  }


createNew=async()=>{
  if (!await this.validate()){
    return;
  }

  this.setState({
    disabled: true,
  });
  await axios.post(`${SERVER_URL}/LostItems/`, {
    
    shortDescription: this.state.shortDescription,
    longDescription: this.state.longDescription,
    itemState:this.state.itemState,
    keywords:this.state.keywords,
    //claimCallengerDetails: this.state.claimCallengerDetails,
    locationName:this.state.locationName,
    publishPicture: this.state.publishPicture,
    isPublished:this.state.isPublished,
    foundDate: (this.state.foundDate) ? new Date(this.state.foundDate) : new Date(),
    returnedDate: (this.state.returnedDate) ? new Date(this.state.returnedDate) : undefined,
    dateLost:this.state.dateLost,
    base64Icon: this.state.base64Icon,
    storageLocation: this.state.storageLocation,
    isExpensiveItem: this.state.isExpensiveItem,
    foundByName: this.state.foundByName,
    loggedByName: this.state.loggedByName,
    itemNumber:this.state.itemNumber,
    airportCd:this.state.airportCd,
    terminal:this.state.terminal,
    flightNumber:this.state.flightNumber,
    seat:this.state.seat,
    pnr:this.state.pnr,
    gate:this.state.gate,
    section:this.state.section,
    row:this.state.row,
    parkingLot:this.state.parkingLot,
    contacted:this.state.contacted,
    contactedDate: (this.state.contactedDate) ? new Date(this.state.contactedDate) : undefined,
    donateDisposeNote:this.state.donateDisposeNote,
    donateDisposeDate:(this.state.donateDisposeDate) ? new Date(this.state.donateDisposeDate) : undefined,
    barCodeValue:this.state.barCodeValue,
    foundByEmployeeId:this.state.foundByEmployeeId,
    containsCash : this.state.containsCash,
    cashAmount:this.state.cashAmount,
    cashCurrencyCd:this.state.cashCurrencyCd,
    returnToFinderDate:(this.state.returnToFinderDate) ? new Date(this.state.returnToFinderDate) : undefined,
    note: this.state.note,
    releaseDate:(this.state.releaseDate) ? new Date(this.state.releaseDate) : undefined,
    storageLocationId: this.state.storageLocationId,
    ownerName:this.state.ownerName,
    isReturnedToStaff:this.state.isReturnedToStaff,
    returnedToStaffName:this.state.returnedToStaffName,
    finderClaimed:this.state.finderClaimed,
    surveillanceStaffName:this.state.surveillanceStaffName,
    category:this.state.category,
}, {
  headers: { 
    'Authorization': `Bearer ${auth0Client.getIdToken()}`,
    'venueId': auth0Client.getActiveVenuedId()
  }
})
.then((res)=>{
    //this.props.history.push('/');
    // Show saved successful
    
//console.log(res.data)
    this.setState({
      showAlert:false,
      disabled: false,
      showSuccess: true,
      id: res.data.objectId,
      lostItem: res.data, 
      itemNumber: res.data.itemNumber
  })
  ToastStore.success('Lost Item Saved Successfully!');
})
.catch ((e)=>{
    
    this.setState({
        showAlert:true,
        disabled: false,
        error:e,

    })
    ToastStore.error(this.state.error.response.data);
})


}

  submit=async()=>{

    if (!await this.validate()){
      return;
    }

    this.setState({
      disabled: true,
    });

    await axios.put(`${SERVER_URL}/LostItems/`, {
        id:this.state.id,
        shortDescription: this.state.shortDescription,
        longDescription: this.state.longDescription,
        itemState:this.state.itemState,
        keywords:this.state.keywords,
        //claimCallengerDetails: this.state.claimCallengerDetails,
        locationName:this.state.locationName,
        publishPicture: this.state.publishPicture,
        isPublished:this.state.isPublished,
        foundDate: (this.state.foundDate) ? new Date(this.state.foundDate) : new Date(),
        returnedDate: (this.state.returnedDate) ? new Date(this.state.returnedDate) : undefined,
        base64Icon: this.state.base64Icon,
        storageLocation : this.state.storageLocation,
        isExpensiveItem: this.state.isExpensiveItem,
        foundByName: this.state.foundByName,
        loggedByName: this.state.loggedByName,
        itemNumber: this.state.itemNumber,
        
        airportCd:this.state.airportCd,
        terminal:this.state.terminal,
        flightNumber:this.state.flightNumber,
        seat:this.state.seat,
        pnr:this.state.pnr,
        gate:this.state.gate,
        section:this.state.section,
        row:this.state.row,
        parkingLot:this.state.parkingLot,
        contacted:this.state.contacted,
        contactedDate: (this.state.contactedDate) ? new Date(this.state.contactedDate) : undefined,
        donateDisposeNote:this.state.donateDisposeNote,
        donateDisposeDate:(this.state.donateDisposeDate) ? new Date(this.state.donateDisposeDate) : undefined,
        barCodeValue:this.state.barCodeValue,
        foundByEmployeeId:this.state.foundByEmployeeId,
        containsCash : this.state.containsCash,
        cashAmount:this.state.cashAmount,
        cashCurrencyCd:this.state.cashCurrencyCd,
        returnToFinderDate:this.state.returnToFinderDate,
        note: this.state.note,
        releaseDate:(this.state.releaseDate) ? new Date(this.state.releaseDate) : undefined, 
        storageLocationId: this.state.storageLocationId,
        ownerName:this.state.ownerName,
        isReturnedToStaff:this.state.isReturnedToStaff,
        returnedToStaffName:this.state.returnedToStaffName,
        finderClaimed:this.state.finderClaimed,
        surveillanceStaffName:this.state.surveillanceStaffName,
        category:this.state.category,
    }, {
      headers: { 
        'Authorization': `Bearer ${auth0Client.getIdToken()}`,
        'venueId': auth0Client.getActiveVenuedId()
      }
    })
    .then((res)=>{
        //this.props.history.push('/');
        // Show saved successful
        if(res.status!==200){
          // console.log(JSON.stringify(res));
           ToastStore.error("An error occured: " + res.response.statusText);
         }else{
           ToastStore.success('Item Saved Successfully!');
           this.setState({
            itemNumber:  res.data.itemNumber
           });
         }


        this.setState({
          showAlert:false,
          disabled: false,
          showSuccess: true,
         

      })
      //ToastStore.success('Lost Item Saved Successfully!');
    })
    .catch ((e)=>{
        
        this.setState({
            showAlert:true,
            disabled: false,
            error:e,

        })
        ToastStore.error(e.message);
    })


  }

  // new claims
  onOpenModal = () => {
    this.setState({ showNewClaim: true });
  };
 
  onCloseModal = () => {
    this.setState({ showNewClaim: false });
  };

  // existing claims
  onOpenClaimModal = () => {
    this.setState({ showOpenClaim: true });
  };
 
  onCloseClaimModal = () => {
    this.setState({ showOpenClaim: false });
  };

  // existing claims
  onOpenReturnModal = () => {
    this.setState({ showNewReturn: true });
  };
 
  onCloseReturnModal = () => {
    this.setState({ showNewReturn: false });
  };



  /******************************************************************************
  NAME:  renderCameraModal
  DESCR: Displays a modal view of the webcamera
  ******************************************************************************/
  renderCameraModal=()=>{
      return(
        <Modal open={this.state.showCamera} onClose={()=>this.setState({showCamera:false})} center>
          <Camera lostItemId={this.state.id} isModalDisplay={true} update={this.updateCameraResults}/>
      </Modal> 
      )
  }


  updateCameraResults=(results)=>{
    if(results){
      this.setState({
        shortDescription:results.title,
        keywords:results.keywords,

        base64Icon:results.base64Image,
        url:results.base64Image,
        showCamera:false
      })
    }
  }





  openPrintLabel =()=>{

    var params = this.state.id + '&tid=' + auth0Client.getIdToken() + '&vid=' + auth0Client.getActiveVenuedId();

    window.open(`${LOCAL_URL}/LostItems/PrintLabel/` + params, '_blank', 'menubar=1,toolbar=1, location=0');

  }
  openSelectedClaim = (claimId) =>{
   //console.log(claimId);
    this.props.history.push('/Claim/' + claimId);
    /*this.setState({
      refreshLostItemClaims: false,
      selectedClaimId:claimId,
      showOpenClaim:true,
    });
    */
  }


   refreshClaims =async(lostItemId)=>{
    var lookupId = (lostItemId) ? lostItemId : this.state.id;

   // console.log("refreshing claims for " + lookupId);
    if (!lookupId) { return ;}



      try {
          axios.get(`${SERVER_URL}/Claims/claimsForLostitem/` + lookupId,{
            headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}` }
          }).then((res)=>{
            var claims  = res.data;
            
            if (claims){
              this.setState({
                claims: claims,
                selectedClaim: (claims.length ===1)? claims[0]: undefined
            });
            }
          }).catch((e)=>{

          });
        }catch(e){


        }
        this.setState({ showOpenClaim: false });
        this.setState({ showNewClaim: false });
  }


  

   renderToast=()=>{
    return <div>
        
        <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
    </div>
}



  validate=async()=>{

    // check the short Description
    if (!this.state.shortDescription) {alert('invalid or missing title'); return false;}
    // check long description
    if (!this.state.longDescription) {alert('invalid or missing description'); return false;}
    
    return true;


  }


  renderAlert=()=>{
    if (this.state.showAlert){
        
        return (
            <Alert color='danger' onDismiss={this.handleDismiss}>
            <h4>Oh snap! You got an error!</h4>
            <p>{this.state.error.response.data}</p>
          </Alert>
        );
    }

}
renderSavedSuccessAlert=()=>{
  if (this.state.showAlert){
      
      return (
          <Alert color='success' onDismiss={this.handleDismiss}>
          <h4>Oh snap! You got an error!</h4>
          <p>{this.state.error.response.data}</p>
        </Alert>
      );
  }

}
claim=()=>{
  // Show new Claim component
  if (this.state.id!==-1){
      this.props.history.push('/NewClaim/' + this.state.id +'/true');

      //this.props.history.push('/NewClaim/' + '' +'true');
      //this.props.history.push('/Claim/-1');

      //this.setState({
      //  showNewClaim: true,
      //})
  }else{
    // Need to save first
    ToastStore.error("The lost item must be saved prior to creating a Claim");
  }
}
createReturn=()=>{

 

  // Show new Return component
  if (this.state.id!==-1){
    console.log('return button');
      this.setState({
        showNewReturn: true,
      })
  }else{
    // Need to save first
    ToastStore.error("The lost item must be saved prior to creating a Return");
  }
}


onReturnedDateChanged= date => this.setState({ returnedDate:date });
onfoundDateChange = date => this.setState({ foundDate:date });
oncontactDateChange = date => this.setState({ contactedDate:date });
onReturnedDonateDisposeDateChanged= date => this.setState({ donateDisposeDate:date });
onReturnToFinderDateDateChanged= date => this.setState({ returnToFinderDate:date });
onReleaseDateChanged= date => this.setState({ releaseDate:date });

archive=()=>{

// Show archive component

}  

renderLargeImage=()=>{

  return(

 
      <Modal open={this.state.displayLargeImageModal} onClose={()=>this.setState({displayLargeImageModal:false})} center>
          <ReactImageMagnify  style={{width:700, height:600}} enlargedImagePosition='over' {...{
                                    smallImage: {
                                        alt: this.state.shortDescription,
                                        isFluidWidth: false,
                                        src: this.state.selectedImageUrl,
                                        width:700,
                                        height:600
                                    },
                                    largeImage: {
                                        src: this.state.selectedImageUrl,
                                        width: 1800,
                                        height: 1600
                                    },
                                    isHintEnabled: true,
                                    shouldHideHintAfterFirstActivation: false
                                }} />
       
          <button title="Close"    className="btn btn-info" onClick={()=>{this.setState({displayLargeImageModal:false})}}>Close </button>
      </Modal>

      )
}
renderItemStatus =()=>{

  if (this.state.itemState==='C'){
    return (
      <span className="text-success">CLAIMED </span>
    )

  }else if(this.state.itemState==='R'){
    return (
      <span className="text-success">RETURNED </span>
    )
  }
  else{
    return (
      <span className="text-danger">UNCLAIMED</span>
    )
  }
}

renderGoBack =()=>{
  return (
    <div className='row'>
      <div className='col-10'>
          <button className="btn btn-secondary" onClick={() => this.props.history.goBack()}><h5> BACK </h5></button>
      </div>
      <div className='col'>
          <button className="btn btn-secondary" onClick={() => {this.setState({displayAuditLog:true})}}><h6>Change Log...</h6></button>
      </div>
    </div>
   
  )
}


renderReturnButton=()=>{
  if (this.state.id!==-1){
    
    return(
      <button
      disabled={this.state.disabled || auth0Client.lfReadOnly===true}
      className="btn btn-success"
      onClick={() => {this.createReturn()}}>
      Request Shipping Label
    </button>
    )
  }else{
    return(
     null
    )
  }
}


renderSaveButton=()=>{
  if (this.state.id!==-1){
    return(
      <button
      disabled={this.state.disabled || auth0Client.lfReadOnly===true}
      className="btn btn-primary"
      onClick={() => {this.submit()}}>
      Update
    </button>
    )
  }else{
    return(
      <button
      disabled={this.state.disabled || auth0Client.lfReadOnly===true}
      className="btn btn-success"
      onClick={() => {this.createNew()}}>
      Save
    </button>
    )
  }
}

renderVenueTypeSection=()=>{
  if (this.state.venueTypeCd==='A'){
    return (
      this.renderAirlineLocation()
    )
  }else if (this.state.venueTypeCd==='S'){
    return (
      this.renderStadiumLocation()
    )
  }
}



renderStadiumLocation=()=>{

  return(
<div className="col-md">
    <h5> Stadium Location Detail </h5> <br/>

        <div className="form-group">
        <div className='row'>
            <div className='col'>
            <label htmlFor="Section" className='text-primary'>Section or Box:</label>
                            <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="section"
                              className="form-control"
                              placeholder="The section# or box name"
                              value= {this.state.section}
                            />
            </div>
            <div className='col'>
            <label htmlFor="Row" className='text-primary'>Row:</label>
                            <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="row"
                              className="form-control"
                              placeholder="The row where the item was found"
                              value= {this.state.row}
                            />
            </div>
            <div className='col'>
            <label htmlFor="Seat" className='text-primary'>Seat:</label>
                            <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="seat"
                              className="form-control"
                              placeholder="The seat where the item was found"
                              value= {this.state.seat}
                            />
            </div>


        </div>
        <div className='row'>
            <div className='col'>
            <label htmlFor="parkingLot" className='text-primary'>Parking Lot:</label>
                            <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="parkingLot"
                              className="form-control"
                              placeholder="Parking Lot"
                              value= {this.state.parkingLot}
                            />
            </div>
            <div className='col'>
            
            </div>


        </div>
    </div>
  </div>
  )

}



renderAirlineLocation=()=>{

  //if (this.state.venueTypeCd==='A'){

    return (

    <div className="col-md">
    <h5> Airline Location Detail </h5> <br/>

        <div className="form-group">
        <div className='row'>
            <div className='col'>
            <label htmlFor="airportCd" className='text-primary'>Airport Code:</label>
                            <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="airportCd"
                              className="form-control"
                              placeholder="Airport code"
                              value= {this.state.airportCd}
                            />
            </div>
            <div className='col'>
            <label htmlFor="terminal" className='text-primary'>Terminal:</label>
                            <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="terminal"
                              className="form-control"
                             
                              value= {this.state.terminal}
                            />
            </div>
            <div className='col'>
            <label htmlFor="gate" className='text-primary'>Gate/Lounge:</label>
                            <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="gate"
                              className="form-control"
                             
                              value= {this.state.gate}
                            />
            </div>


        </div>
        <div className='row'>
            <div className='col'>
            <label htmlFor="flightNumber" className='text-primary'>Flight#:</label>
                            <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="flightNumber"
                              className="form-control"
                              placeholder="Flight Number"
                              value= {this.state.flightNumber}
                            />
            </div>
            <div className='col'>
            <label htmlFor="seat" className='text-primary'>Seat:</label>
                            <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="seat"
                              className="form-control"
                              placeholder="The seat or row where found (i.e 23B)"
                              value= {this.state.seat}
                            />
            </div>


        </div>
    </div>
  </div>

    )

}


onFileChange=(e)=>{
  let files= e.target.files;
  if (files.length ===1){
      let reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload=(e)=>{
        var data = e.target.result;
        //console.log(data);
        // upload the new file to the venue account
        this.setState({
          base64Icon:data,
          url:data,
        })
      }
  }

}




handleApiLoaded = (map, maps) => {
  // use map and maps objects
 // console.log(map);
  //map.styles= 
};
 
setReleaseDatePeriod=(days)=>{
      let newDate =  moment(new Date()).add(days,'days').toDate();
      this.setState({
        releaseDate:newDate
      }) 
}

renderStorageLocation=()=>{

  if (auth0Client.getDefaultVenue().enableWarehouse){
   return(
    <div>
        <label htmlFor="storageLocation" className='text-primary'>Current/Storage Location Of Found Item:</label>
            <select
            disabled={this.state.disabled}
            type="text"
            onChange={this.handleInputStorageChange}  //important! 
            name="storageLocation"
            className="custom-select"
            placeholder=""
            value= {this.state.storageLocation}
          > 
           <option key='' value=''></option>
                {this.state.storageLocations.map(item => (
                  <option key={item._id} value={item.name} id={item._id}>
                    {item.name + ' (' + item.description + ')'}
                  </option>
                ))}
        </select>   
    </div>
    
   )
  }else{
    return(
      <div>
            <label htmlFor="exampleInputEmail1" className='text-primary'>Storage Location Of Found Item:</label>

          <input
            disabled={this.state.disabled}
            type="text"
            onChange={this.handleInputChange}
            name="storageLocation"
            className="form-control"
            placeholder=""
            value= {this.state.storageLocation}
          />
      </div>
    
    )
  }
}

renderModalLocationList=()=>{
  return(
    <Modal open={this.state.showLocationList} onClose={()=>this.setState({showLocationList:false})} center>
      <div className='container'>
        <div className='row'>
          <div className='col'>
            <h4>Locations</h4>
            <hr/>
            <label htmlFor="locationName" className='text-info'>Select from the list of locations:</label>
            <br/>
            <select className="form-control" multiple={false} value={this.state.locationName} onChange={(e)=>this.setState({locationName:e.target.value, showLocationList:false})}>
              {this.state.foundLocations.map((location, index) => (
                <option key={index} value={location.name}>{location.name}</option>
              ))}
            </select>
            <br/>
           <small className="text-muted">Locations can be added in Settings...Locations.  Type should be 'ExpressQR'</small>
           <br/><br/>
          </div>
        </div>
      </div>
    </Modal>
  )
}


render() {

  
    const { showNewClaim,showNewReturn, showOpenClaim} = this.state;
   
    return (
      <div style={{margin:'5px'}}>
        {this.renderGoBack()}
        {this.renderToast()}
   
        <div className="card-header alert-info" style={{padding:2}}>
                  
                  
                  <div className="row">
                        <div className='col'> 
                            
                                  <h2 className="display-5" style={{color:'black'}}>{this.state.shortDescription}</h2>
                                  
                                  <p  style={{color:'black', fontSize:'15px'}}><b>Date Found:</b>  {LostItemFunctions.formatDateTime(this.state.foundDate)}</p>
                                
                            
                                  <div className="row">
                                      <div className='col'>
                                      <img  style={{maxWidth:250, maxHeight:250}}  alt={this.state.shortDescription}  src={this.state.url} onClick={()=>{this.setState({selectedImageUrl:this.state.url, displayLargeImageModal:true})}}/>
                                      </div>
                                      <div className='col'>
                                      <img  style={{maxWidth:250, maxHeight:250}}  alt={this.state.shortDescription}  src={this.state.pic2Url} onClick={()=>{this.setState({selectedImageUrl:this.state.pic2Url, displayLargeImageModal:true})}}/>
                                      </div>
                                      <div className='col'>
                                      <img  style={{maxWidth:250, maxHeight:250}}  alt={this.state.shortDescription}  src={this.state.pic3Url} onClick={()=>{this.setState({selectedImageUrl:this.state.pic3Url, displayLargeImageModal:true})}}/>
                                      </div>
                              
                                  </div>
                                    <br/>
                                    <input type="file" name='file' onChange={(e)=>this.onFileChange(e)} />
                                    <button className="btn btn-primary btn-sm" onClick={()=>this.setState({showCamera:true})}>Camera</button>
                        </div>
                        <div className='col'> 


                             
                                  <h2  style={{color:'black', fontSize:'15px'}}>ITEM#: {this.state.itemNumber} -{this.renderItemStatus()}</h2>
                                 
                              
                              
                              <div style={{ backgroundColor:'transparent',width:"100%",height:300}}>
                              <GoogleMapReact 
                                bootstrapURLKeys={{ key: "AIzaSyA6F5Cxr4qlW8xqS3qcDsTFG7YAbUriD8E" }}
                                //yesIWantToUseGoogleMapApiInternals
                                //onGoogleApiLoaded={({ map, maps }) => this.handleApiLoaded(map, maps)}
                                center={this.state.center}
                                defaultZoom={this.state.zoom}
                                options={(map)=>{
                                  return {
                                    panControl: false,
                                    mapTypeControl: true,
                                    scrollwheel: true,
                                    styles: [{ stylers: [{ 'saturation': -100 }, { 'gamma': 0.8 }, { 'lightness': 4 }, { 'visibility': 'on' }] }]
                                  }
                                }}
                              >
                                <AnyReactComponent
                                  lat={this.state.center.lat}
                                  lng={this.state.center.lng}
                                  text={'item'}
                                />
                              </GoogleMapReact>
                           </div>
                           <br/>
                           <p  style={{color:'black', fontSize:'15px'}}><b>Created On:</b>  {LostItemFunctions.formatDateTime(this.state.createdAt)}  <b> &nbsp; | &nbsp; Last Updated</b>  {LostItemFunctions.formatDateTime(this.state.updatedAt)}</p>
                          

                        </div>
                       
                </div>

             
                    
                    
                     
                  <div className="row">
                    <div className="col-sm">
                    
                   
                    {/* <Toggle labelRight="Publish on Website" checked={this.state.isPublished} onToggle={value => this.setState({isPublished:value})} /> */}
                     
                   
                    
                    

                    </div>

                    <div className='col-sm'>
                    
                    </div>
                    
                    
                    
                    </div>
                
          </div>
             <div className="row">   
                  <div className="col-md">
                  <h5> Detail </h5> <br/>

                      <div className="form-group">
                      <div className='row'>
                          <div className='col'>
                          <label htmlFor="exampleInputEmail1" className='text-danger'>Title (required):</label>
                                          <input
                                            disabled={this.state.disabled}
                                            type="text"
                                            autoComplete="off"
                                            onChange={this.handleInputChange}
                                            name="shortDescription"
                                            className="form-control"
                                            placeholder="Please provide title for the lost Item."
                                            value= {this.state.shortDescription}
                                          />
                          </div>
                          <div className='col'>
                          <label htmlFor="exampleInputEmail1" className='text-primary'>Item #:</label>
                                          <input
                                            disabled={this.state.disabled}
                                            type="text"
                                            onChange={this.handleInputChange}
                                            name="itemNumber"
                                            className="form-control"
                                            placeholder="This will autofill if left blank"
                                            value= {this.state.itemNumber}
                                          />
                          </div>


                      </div>
                      
                                          
                      <div className='row'>

                          <div className='col-6'>
                          <label htmlFor="exampleInputEmail1" className='text-danger'>Description (required):</label>
                                          <textarea
                                            disabled={this.state.disabled}
                                            autoComplete="off"
                                            type="text"
                                            name="longDescription"
                                            onChange={this.handleInputChange}
                                            className="form-control"
                                            placeholder="Please provide a description for the lost Item."
                                            value= {this.state.longDescription}
                                          />
                          </div>
                          
                          <div className='col'>
                              <label htmlFor="category" className='text-primary'>Product category:</label>
                              <select
                                  disabled={this.state.disabled}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  name="category"
                                  className="custom-select"
                                  placeholder=""
                                  value= {this.state.category}
                                  autoComplete='off'
                                > 
                                {this.state.categoriesMap.map(item =>(
                                  <option key={item.name} value={item.name}>
                                  {item.name}
                              </option>
                                ))}
                                              
                                                                    
                              </select>
                          </div>
                      </div>
                                       
                        
                                          
                                                <div className="form-group">
                                              <label htmlFor="note" className='text-primary'>Notes:</label>

                                                <textarea
                                                  disabled={this.state.disabled}
                                                  type="text"
                                                  onChange={this.handleInputChange}
                                                  value= {this.state.note}
                                                  name="note"
                                                  className="form-control"
                                                  placeholder="Use this input for team notes and other internal communication"
                                                  autoComplete="off"
                                                />
                                          </div>
                                         

                                                <div className="form-group">
                                                    <div className='row' style={{alignItems:'center'}}>
                                                        <div className='col'>
                                                              <Toggle id='expensive' labelRight="Expensive Item?" checked={this.state.isExpensiveItem} onToggle={value => this.setState({isExpensiveItem:value})} /> 

                                                          </div>
                                                          <div className='col'>
                                                                <label htmlFor="exampleInputEmail1" className='text-primary'>Bag Barcode:</label>
                                                                <input
                                                                    disabled={this.state.disabled}
                                                                    type="text"
                                                                    onChange={this.handleInputChange}
                                                                    name="barCodeValue"
                                                                    className="form-control"
                                                                    placeholder=""
                                                                    value= {this.state.barCodeValue}
                                                                    autoComplete="off"
                                                                  />
                                                          </div>
                                                    </div>
                                                    <div className='row' style={{alignItems:'center'}}>
                                                        <div className='col' >
                                                            <Toggle id='containsCash' labelRight="Contains Cash?" checked={this.state.containsCash} onToggle={(value) => {
                                                                      const amt = this.state.cashAmount;
                                                                      const ccy = this.state.cashCurrencyCd;
                                                                      this.setState({
                                                                            containsCash:value,
                                                                            cashAmount: (value) ? amt : 0.00,
                                                                            cashCurrencyCd: (value)? ccy : ''
                                                                        })}} /> 
                                                        </div>
                                                        <div className='col-3'>
                                                        <label htmlFor="cashAmount" className='text-primary'>Amount:</label>
                                                          <input
                                                           autoComplete="off"
                                                                     disabled={!this.state.containsCash}
                                                                      type="numeric"
                                                                      onChange={this.handleInputChange}
                                                                      name="cashAmount"
                                                                      className="form-control"
                                                                      placeholder=""
                                                                      value= {this.state.cashAmount}
                                                                    />
                                                        </div>
                                                        <div className='col'>
                                                            <label htmlFor="cashCurrencyCd" className='text-primary'>Currency:</label>
                                                              <select
                                                                disabled={!this.state.containsCash}
                                                                type="text"
                                                                onChange={this.handleInputChange}
                                                                name="cashCurrencyCd"
                                                                className="custom-select"
                                                                placeholder=""
                                                                value= {this.state.cashCurrencyCd}
                                                              > 
                                                            {CURRENCY_LIST.map(item => (
                                                              <option key={item.code} value={item.code}>
                                                                {item.code + ' ' + item.name}
                                                              </option>
                                                            ))}
                                                            </select>   
                                                        </div>
                                                    </div>
                                                    </div>



                                            <label htmlFor="exampleInputEmail1" className='text-primary'>Enter keywords that describe the item (seperate with commas):</label>

                                          <input
                                            disabled={this.state.disabled}
                                            autoComplete="off"
                                            type="text"
                                            onChange={this.handleInputChange}
                                            name="keywords"
                                            className="form-control"
                                            placeholder="Please provide keywords that describe lost Item. i.e.  blue, metal"
                                            value= {this.state.keywords}
                                          />

                                          <div className='row'>
                                            <div className='col-7'>
                                                   <label htmlFor="exampleInputEmail1" className='text-primary'>Location / ROOM# (i.e. Lobby' or '401'):</label>
                                                  
                                            <div className='row'>
                                              <div className='col-8'>
                                                  <input
                                                      autoComplete="off"
                                                        disabled={this.state.disabled}
                                                        type="text"
                                                        onChange={this.handleInputChange}
                                                        name="locationName"
                                                        className="form-control"
                                                        placeholder=""
                                                        value= {this.state.locationName}
                                                      />

                                                 
                                              </div>
                                              <div className='col-4' style={{alignItems:'start'}}>
                                              <button type="button" className="btn btn-outline-info btn-sm" onClick={()=>this.setState({showLocationList:true})}>Locations...</button>
                                            
                                              </div>
                                            </div>
                                              </div>
                                              <div className='col-5'>
                                                   <label htmlFor="exampleInputEmail1" className='text-primary'>Owner/Guest:</label>

                                                  <input
                                                   autoComplete="off"
                                                    disabled={this.state.disabled}
                                                    type="text"
                                                    onChange={this.handleInputChange}
                                                    name="ownerName"
                                                    className="form-control"
                                                    placeholder=""
                                                    value= {this.state.ownerName}
                                                  />
                                              </div>
                                           </div>
                                         
                                          
                                        
                                          
                                          
                                          

                                        
                        </div>
                        <div className='row'>
                          <div className='col'>
                             {this.renderStorageLocation()}
                          </div>
                          <div className='col'>
                          <label htmlFor="loggedByName" className='text-primary'>Logged By:</label>

                            <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="loggedByName"
                              className="form-control"
                              placeholder=""
                              autoComplete="off"
                              value= {this.state.loggedByName}
                            />
                            </div>
                            <div className='col'>
                          <label htmlFor="surveillanceStaffName" className='text-primary'>Surveillance / Sec. Staff:</label>

                            <input
                              disabled={this.state.disabled}
                              type="text"
                              autoComplete="off"
                              onChange={this.handleInputChange}
                              name="surveillanceStaffName"
                              className="form-control"
                              placeholder=""
                              value= {this.state.surveillanceStaffName}
                            />
                            </div>
                        </div>



                        <div className='row'>
                          <div className='col'>
                          <label htmlFor="exampleInputEmail1" className='text-primary'>Date Found:</label>
                                          <br/>
                                           <DatePicker
                                            className="form-control"
                                              onChange={this.onfoundDateChange}
                                              name="foundDate"
                                              selected={this.state.foundDate}
                                              showTimeSelect
                                              dateFormat="Pp"
                                            /> 
                          </div>
                          <div className='col'>
                          <label htmlFor="foundBy" className='text-primary'> Found By:</label>
                          <input
                                              disabled={this.state.disabled}
                                              type="text"
                                              onChange={this.handleInputChange}
                                              name="foundByName"
                                              className="form-control"
                                              placeholder=""
                                              autoComplete="off"
                                              value= {this.state.foundByName}
                                            />
                                          

                          </div>
                          <div className='col text-center'>
                            <label htmlFor="finderClaimed" className='text-primary'> Will Claim:</label>
                            <br></br>
                            <Toggle id='finderClaimed' labelRight="" checked={this.state.finderClaimed} onToggle={value => this.setState({finderClaimed:value})} /> 
                                          

                          </div>

                          <div className='col'>
                          <label htmlFor="foundBy" className='text-primary'> Found By-Emp. ID:</label>
                          <input
                                              disabled={this.state.disabled}
                                              type="text"
                                              onChange={this.handleInputChange}
                                              name="foundByEmployeeId"
                                              className="form-control"
                                              placeholder=""
                                              value= {this.state.foundByEmployeeId}
                                              autoComplete="off"
                                            />
                                          

                          </div>
                          <div className='col'>
                            <label htmlFor="returnToFinderDate" className='text-primary'> Return To Finder Dt.:</label>
                          <DatePicker
                                className="form-control"
                                autoComplete="off"
                                onChange={this.onReturnToFinderDateDateChanged}
                                name="returnToFinderDate"
                                selected={this.state.returnToFinderDate}
                              />          
                                          

                          </div>
                         

                         
                        </div>

                     
                    
                      <div className='row' style={{ paddingTop:'10px',  alignItems:'center'}}>
                          <div className='col-3'><h6 className='text-info'>Release Date</h6> Auto Fill:</div>
                          <div className='col'><button type="button" className="btn btn-outline-info btn-sm" onClick={()=>this.setReleaseDatePeriod(7)}>7</button></div>
                          <div className='col'><button type="button" className="btn btn-outline-info btn-sm" onClick={()=>this.setReleaseDatePeriod(30)}>30</button></div>
                          <div className='col'><button type="button" className="btn btn-outline-info btn-sm" onClick={()=>this.setReleaseDatePeriod(45)}>45</button></div>
                          <div className='col'><button type="button" className="btn btn-outline-info btn-sm" onClick={()=>this.setReleaseDatePeriod(60)}>60</button></div>
                          <div className='col'><button type="button" className="btn btn-outline-info btn-sm" onClick={()=>this.setReleaseDatePeriod(90)}>90</button></div>
                          <div className='col'><button type="button" className="btn btn-outline-info btn-sm" onClick={()=>this.setReleaseDatePeriod(180)}>6Mo.</button></div>
                          <div className='col'><button type="button" className="btn btn-outline-info btn-sm" onClick={()=>this.setReleaseDatePeriod(365)}>1Yr.</button></div>
                          <div className='col-3'>
                         
                          <DatePicker
                                  className="form-control"
                                    onChange={this.onReleaseDateChanged}
                                    name="releaseDate"
                                    selected={this.state.releaseDate}
                                  />          


                          </div>

                      </div>                                         

                    </div>
                    <div className="col-md">

                    {
                      this.renderVenueTypeSection()}
                      
                  
                    <h5> Status </h5> <br/>

                     <div className="form-group">
                     <div className='row'>
                          <div className='col-3'>
                              <Toggle id='contacted' labelRight="Guest Contacted?" checked={this.state.contacted} onToggle={value => this.setState({contacted:value, contactedDate: (value) ? new Date(): undefined})} /> 

                          </div>
                          <div className='col-3 text-left'>
                          <label htmlFor="exampleInputEmail1" className='text-primary'><b>Contacted On:</b></label>
                                        
                                           <DatePicker
                                            autoComplete="off"
                                            className="form-control"
                                              onChange={this.oncontactDateChange}
                                              name="contactedDate"
                                              selected={this.state.contactedDate}
                                            /> 
                          </div>
                      </div>

                      <div className='row'>
                          <div className='col-6'>
                          <label htmlFor="exampleInputEmail1"> <b>Current Status:</b></label>
                                         
                                         <select className='custom-select'  value={this.state.itemState} name='itemState' onChange={this.handleInputChange}>
                                           <option value="A">Archived</option>
                                           <option value="C">Claimed</option>
                                           <option value="D">Donated</option>
                                           <option value="T">Disposed</option>
                                           <option value="R">Returned</option>
                                           <option value="Q">Unclaimed</option>
                   
                                         </select>
                            </div>
                            <div className='col-2 align-middle'>
                                <br/><br/>
                                <Toggle 
                                 rightBackgroundColor="green"
                                        id='isReturnedToStaff' disabled={this.state.itemState!=='R'} labelRight="Returned to staff" 
                                        checked={this.state.isReturnedToStaff} onToggle={value => this.setState({isReturnedToStaff:value, returnedToStaffName: (this.state.foundByName && value) ? this.state.foundByName: ''})} /> 

                           </div>
                           <div className='col-4 align-middle'>
                               
                           <label htmlFor="exampleInputEmail1"> <b>Returned To Staff Name:</b></label>
                                 <input
                                              disabled={this.state.itemState!=='R'}
                                              type="text"
                                              onChange={this.handleInputChange}
                                              name="returnedToStaffName"
                                              className="form-control"
                                              placeholder="Enter staff name"
                                              value= {this.state.returnedToStaffName}
                                              autoComplete="off"
                                            />

                           </div>


                      </div>
                     

                      <div className='row'>
                          <div className='col'>
                          <label htmlFor="exampleInputEmail1">Date Returned Customer:</label>
                            <br/>
                              <DatePicker
                              className="form-control"
                                onChange={this.onReturnedDateChanged}
                                name="foundDate"
                                selected={this.state.returnedDate}
                                autoComplete='off'
                              />             
                            </div>
                            <div className='col'>
                              <label htmlFor="exampleInputEmail1">Date Disposed/Donated:</label>
                                <br/>
                                  <DatePicker
                                  className="form-control"
                                    onChange={this.onReturnedDonateDisposeDateChanged}
                                    name="donateDisposeDate"
                                    selected={this.state.donateDisposeDate}
                                    autoComplete='off'
                                  />             
                                </div>
                            <div className='col'>
                            <label htmlFor="donateDisposeNote" className='text-primary'> Dontate/Dispose Note:</label>
                          <input
                                              disabled={this.state.disabled}
                                              type="text"
                                              onChange={this.handleInputChange}
                                              name="donateDisposeNote"
                                              className="form-control"
                                              placeholder=""
                                              value= {this.state.donateDisposeNote}
                                              autoComplete='off'
                                            />
                            </div>
                      </div>

                               
                     </div>


                    <br/>
                    <div className='row'>
                        <div className='col'>

                        </div>
                    </div>
                      <Tabs>
                        <TabList>
                              <Tab><p className='text-info'><b>Claims</b></p></Tab>
                              <Tab><p className='text-info'><b>Attachments</b></p></Tab>
                        </TabList>

                        <TabPanel>
                              <div className='row'>
                                <div className='col'>
                                    <h5> Claims On This item: </h5> <br/>
                                </div>
                                <div align='right'>
                                <button
                                      disabled={this.state.disabled || (this.state.id===-1)}
                                      className="btn btn-outline-secondary btn-sm"
                                      onClick={() => {this.claim()}}>
                                      New Claim
                                    </button>
                                  </div>
                              </div>  
                            <LostItemClaims claims={this.state.claims} selectClaim={this.openSelectedClaim}/>
                        </TabPanel>
                        <TabPanel>
                        <div className='row'>
                                <div className='col'>
                                    <h5> Attached Files: </h5> <br/>
                                </div>
                              
                              </div>  
                              <Attachments objectType={ATTACHMENT_OBJECT_TYPE_LOSTITEM} ownerObjectId={this.state.id}/>
                          </TabPanel>

                      </Tabs>
                    
                    
                      </div>
                    
              </div>
             
<br/>
                <div className="row">   
               
                 <div className="col-md">
                {this.renderSaveButton()}
                 </div>
                
                 <div className="col-md">
                {this.renderReturnButton()}
                 </div>

               {
                         /*   <div className="col-md">
                            <button
                                disabled={this.state.disabled || auth0Client.lfReadOnly===true}
                                className="btn btn-outline-primary"
                                onClick={() => {this.createReturn()}}>
                                Send Found Item Email
                            </button>
                            </div>

                            */
               }
                 <div align='right'>
                
                      <button
                        disabled={this.state.disabled|| (this.state.id===-1)}
                        className="btn btn-info"
                        onClick={() => {this.openPrintLabel()}}>
                        Print Inventory Tracking Label
                      </button>


                 </div>

                </div>
      {this.renderCameraModal()}
      {this.renderLargeImage()}
      {this.renderModalLocationList()}
       <Modal open={showNewClaim} onClose={this.onCloseModal} center>
          
          <Claim lostItemId={this.state.id} isModalDisplay={true} refreshParent={this.refreshClaims}/>
        </Modal> 

       <Modal open={showOpenClaim} onClose={this.onCloseClaimModal} center>
          
          <Claim claimId={this.state.selectedClaimId} isModalDisplay={true} refreshParent={this.refreshClaims}/>
        </Modal>     

         <Modal open={showNewReturn} onClose={this.onCloseReturnModal} center closeOnOverlayClick={false}>
          
          <ReturnWizard lostItemId={this.state.id} claim={this.state.selectedClaim} isModalDisplay={true} refreshParent={this.refreshClaims} shortDescription={this.state.shortDescription} onClose={this.onCloseReturnModal}/>
        </Modal>  
        <Modal  scrollable={true} open={this.state.displayAuditLog} onClose={()=>this.setState({displayAuditLog:false})}  
              center>
             
             <LostItemAuditChanged  lostItemId={this.state.id}/>
                    
                    
                    
                   
              </Modal>
        <br/>

      </div>
        
    

  
     
     
    )

   

  }
}

export default withRouter(LostItem);